export default "__VITE_ASSET__7dcf98f3__"